import createApiCall from './create';
import detailApiCall from './detail';
import editApiCall from './edit';
import listApiCall from './list';
import unlinkApiCall from './unlink';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  create: createApiCall,
  edit: editApiCall,
  unlink: unlinkApiCall,
};

export default ApiCall;
